import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type OrderDetail } from "./types";

export const localStateSelector = makeModuleStateSelector<OrderDetail.AppState>(defaultState, previewState);
